import {
	API_GET_ALL_LABORATORY,
	API_GET_ALL_LABORATORY_SUCCESS,
	API_GET_ALL_LABORATORY_FAIL,
	API_SEARCH_LABORATORY,
	API_SEARCH_LABORATORY_SUCCESS,
	API_SEARCH_LABORATORY_FAIL
} from '../actions/laboratory';
import { createReducer } from '@reduxjs/toolkit';
import { errorHandler, ErrorAction } from 'utils/error';
import { getVersion } from "services/laboratory";
import { V2_CLIENT } from "config/clientConstants";

const initialState = {
	loading: false,
	list: []
};

const adaptLaboratoryResponse = (laboratory, currentClient) => {
	try {
		if (!laboratory || currentClient !== V2_CLIENT) {
			return laboratory;
		}

		const adapted = { ...laboratory };

		if (adapted.ipRange !== undefined && adapted.ip_range === undefined) {
			adapted.ip_range = adapted.ipRange;
		}
		if (adapted.folderNumFormat !== undefined && adapted.folder_num_format === undefined) {
			adapted.folder_num_format = adapted.folderNumFormat;
		}

		// Keep labParamGroup for the admin UI; just ensure it exists.
		if (adapted.labParamGroup === undefined) {
			adapted.labParamGroup = null;
		}

		return adapted;
	} catch (error) {
		console.error("Error in adaptLaboratoryResponse:", error);
		return laboratory;
	}
};

const adaptLaboratoryPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (Array.isArray(data)) {
				return {
					...payload,
					data: data.map((item) => adaptLaboratoryResponse(item, currentClient)),
				};
			}

			if (typeof data === "object") {
				return {
					...payload,
					data: adaptLaboratoryResponse(data, currentClient),
				};
			}
		}

		return payload;
	} catch (error) {
		console.error("Error in adaptLaboratoryPayloadResponse:", error);
		return action.payload || {};
	}
};

const laboratories = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_LABORATORY]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_LABORATORY_FAIL]: (state, action) => {
		errorHandler('Laboratoire', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_LABORATORY_SUCCESS]: (state, action) => {
		state.loading = false;
		const adaptedPayload = adaptLaboratoryPayloadResponse(action, API_GET_ALL_LABORATORY);
		state.list = adaptedPayload.data || [];
	},

	/** SEARCH **/
	[API_SEARCH_LABORATORY]: (state, action) => {
		state.loading = true;
	},
	[API_SEARCH_LABORATORY_FAIL]: (state, action) => {
		errorHandler('Laboratoire', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_SEARCH_LABORATORY_SUCCESS]: (state, action) => {
		state.loading = false;
		const adaptedPayload = adaptLaboratoryPayloadResponse(action, API_SEARCH_LABORATORY);
		state.list = adaptedPayload.data || [];
	}
});

export default laboratories;
